<div class="table-wrapper">
    <div class="table-title">Live Parameter Table</div>
    <div class="table-scroll">
      <table class="table live-data-table">
        <thead>
          <tr>
            <th class="col-key">Key</th>
            <th class="col-value">{{value1}}</th>
            <th class="col-value">{{value2}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of keyValueArray">
            <td>{{ item.key }}</td>
            <td [ngClass]="{'value-updated': item.value1 !== item.value2}">{{ item.value1 }}</td>
            <td [ngClass]="{'value-updated': item.value1 !== item.value2}">{{ item.value2 }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  